import { FetchError } from './fetch-error';
import { HTTPMethod, ContentTypes } from './request';
/**
 *
 * @description Middleware for automatically logging actions to [CP Analytics][http://confluence.apg.services.gs.com/display/DCP/Analytics]
 * @example Setup
 * import { buildCPLogger } from '@mq/aurora-redux-middleware';
 * const isProd = window.location.host === 'your-prod-host-name.gs.com'; // or any other method you want to use to determine prod
 * const domainPostfix = isProd ? '' : '-qa';
 * const cpalogger = buildCPLogger({
 *    getUrl: () => `https://gs-analytics${domainPostfix}.url.gs.com:8443/appevent`,
 *    getToken: () => isProd ? 'PRODTOKEN' : 'QATOKEN',
 *    shouldLog: (action) => !(/^(?:RECV|XHR_ERROR)/).test(action.type)
 * });
 * const middleware = applyMiddleware(thunkMiddleware, callAPIMiddleware, cpalogger, ...);
 * @param getKerberos - if not provided, then your store must implement `Iwhoami`
 * @example URLS for testing / viewing metrics
 * QA data - http://gs-analytics-qa.url.gs.com:9200/INDEXNAME/Event/_search?sort=timestamp:desc&size=25
 * QA Kibana - http://gs-analytics-qa.url.gs.com:5601
 * PROD Kibana - http://gs-analytics.url.gs.com:5601
 */
var buildLogger = function (config) {
  var _a = config.getUrl,
    getUrl = _a === void 0 ? function () {
      return null;
    } : _a,
    _b = config.getToken,
    getToken = _b === void 0 ? function () {
      return null;
    } : _b,
    _c = config.shouldLog,
    shouldLog = _c === void 0 ? function (a, kerberos) {
      return true;
    } : _c,
    _d = config.addCustomMetrics,
    addCustomMetrics = _d === void 0 ? function (action, kerberos) {
      return null;
    } : _d,
    _e = config.fetch,
    fetch = _e === void 0 ? window.fetch : _e,
    _f = config.getKerberos,
    getKerberos = _f === void 0 ? function (state) {
      return state.whoami && state.whoami.kerberos;
    } : _f,
    _g = config.getEventName,
    getEventName = _g === void 0 ? function (action) {
      return action.type;
    } : _g;
  var url = getUrl();
  var token = getToken();
  if (!url || !token) {
    return function (s) {
      return function (next) {
        return function (a) {
          return next(a);
        };
      };
    };
  }
  var mw = function (s) {
    return function (next) {
      return function (a) {
        // **HELP** - this is obviously a terrible hack - my TS foo isn't up to spec
        var kerberos = getKerberos(s.getState()) || '';
        if (kerberos && shouldLog(a, kerberos)) {
          var payload = {
            token: token,
            event: getEventName(a),
            properties: {
              window: {
                location: {
                  href: window.location.href
                }
              }
            },
            context: {
              user: {
                kerberos: kerberos
              }
            }
          };
          Object.assign(payload.properties, addCustomMetrics(a, kerberos));
          fetch(url, {
            method: HTTPMethod.POST,
            headers: {
              'Content-Type': ContentTypes.JSON
            },
            body: JSON.stringify(payload)
          }).then(checkStatus).then(null, function (err) {
            // tslint:disable-next-line: no-console
            console.error('POST to cp-analytics failed', err);
          });
        }
        return next(a);
      };
    };
  };
  return mw;
};
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    throw new FetchError('Failed to log to analytics service', response.statusText, response.status, response.body);
  }
}
export { buildLogger, checkStatus };